import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { fetchWebloginVehicles } from '../actions';
import { selectMe, selectWork } from '../../Api/selectors';
import { WEBLOGIN_FETCH_VEHICLES } from '../constants';
import { Loader } from '../../../components/Loader';
import { selectWebloginVehicles } from '../selectors';
import { VehicleAvatar } from '../../../components/VehicleAvatar';
import { HBox } from '../../../components/Box';
import { VehiclesOverview } from '../../Vehicles/pages/overview';

const Container = styled.div`
  .vehicle-row {
    border-bottom: 1px solid #ddd;
    padding: 6px;

    .img {
      margin: 0;
    }

    > div {
      min-width: 100px;
    }
  }
`;
const STATE = {
  selected: null,
};
/* eslint-disable react/prefer-stateless-function */
class WebloginVehiclesPageComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.get();
  }

  get weblogin() {
    return this.props.me.weblogin;
  }

  render() {
    if (this.props.loading || !this.props.vehicles?.length) return <Loader small />;
   
    return (
      <Container>
        <VehiclesOverview weblogin={this.weblogin} webloginVehicles={this.props.vehicles} />
      </Container>
    );
  }

  renderVehicle(vehicle) {
    return (
      <HBox key={vehicle.id} left vCenter className="vehicle-row" gap={24} onClick={this.tofn(`/vehicles/${vehicle.id}`)}>
        <div>
          <VehicleAvatar vehicle={vehicle} />
          <div style={{ color: '#aaa', fontSize: '12px' }}>{vehicle.id}</div>
        </div>
        <div>{vehicle.regplate}</div>
        <div>
          {vehicle.brand_name}
          <br />
          {vehicle.model_name}
          <br />
          {vehicle.model_extra}
          <br />
        </div>
      </HBox>
    );
  }
}

WebloginVehiclesPageComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    loading: selectWork(WEBLOGIN_FETCH_VEHICLES),
    vehicles: selectWebloginVehicles(),
    me: selectMe(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    get() {
      dispatch(fetchWebloginVehicles());
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const WebloginVehiclesPage = compose(withConnect, withRouter)(WebloginVehiclesPageComp);
